import React from "react";
import Header from "../navigation/header";
import About from "./about";
import Footer from "../navigation/footer";


export default function AboutPage(){
    return(
        <>
            <Header />
            <About />
            <Footer />

        </>
    )

}